export const configurationOwnerUsernameLabel =
  'io.portainer.kubernetes.configuration.owner';
// the configurationOwnerUsernameLabel is already used for displaying the username in the UI, so add a new label for the id (to check ownership)
export const configurationOwnerIdLabel =
  'io.portainer.kubernetes.configuration.owner.id';
